module.exports = "/images/lupe.svg?3d01d5a0ef367601689821e691bf867a";